<template>
	<div class="mh-middle">
		<div class="mh-middle-inner">
			<ContentTitle title="Dashboard" :data="alerts" />

			<b-row>
				<b-col :lg="invoices.length > 0 ? 4 : 5" xs="12">
					<b-card no-body class="mh-card">
						<b-card-header>
							<h3 class="card-title">Profile</h3>
						</b-card-header>
						<b-card-body class="profile">
							<b-row class="mb-2">
								<b-col cols="12" class="text-center mb-3">
									<ProfileImage :imageUrl="profilePicture" class="profile-picture" />
								</b-col>
								<b-col cols="12" class="name text-center mb-2">
									{{profile.fullname}}
								</b-col>
								<b-col cols="12" class="number text-center mb-3">
									Client # {{profile.userid}}
								</b-col>
							</b-row>
							<b-row class="mb-2">
								<b-col cols="6" class="label">
									Gender
								</b-col>
								<b-col v-if="customerSummary.gender != ''" cols="6">
									{{customerSummary.gender}}
								</b-col>
								<b-col v-else cols="6" class="not-specified">
									Not Specified
								</b-col>
							</b-row>
							<b-row class="mb-2">
								<b-col cols="6" class="label">
									Age
								</b-col>
								<b-col v-if="customerSummary.birthdate != ''" cols="6">
									{{Math.floor(moment.duration(moment().diff(moment(customerSummary.birthdate, 'YYYY-MM-DDTHH:mm:ss'))).asYears())}}
								</b-col>
								<b-col v-else cols="6" class="not-specified">
									Not Specified
								</b-col>
							</b-row>
							<b-row class="mb-2">
								<b-col cols="6" class="label">
									Keyworker
								</b-col>
								<b-col v-if="customerSummary.keyworkername != ''" cols="6">
									{{customerSummary.keyworkername}}
								</b-col>
								<b-col v-else cols="6" class="not-specified">
									Not Specified
								</b-col>
							</b-row>
							<b-row class="mb-2">
								<b-col cols="6" class="label">
									Address
								</b-col>
								<b-col v-if="customerSummary.address != ''" cols="6">
									{{customerSummary.address}}
								</b-col>
								<b-col v-else cols="6" class="not-specified">
									Not Specified
								</b-col>
							</b-row>
							<b-row class="mb-2">
								<b-col cols="6" class="label">
									Home Phone
								</b-col>
								<b-col v-if="customerSummary.homephone != ''" cols="6">
									{{customerSummary.homephone}}
								</b-col>
								<b-col v-else cols="6" class="not-specified">
									Not Specified
								</b-col>
							</b-row>
							<b-row class="mb-2">
								<b-col cols="6" class="label">
									Mobile Phone
								</b-col>
								<b-col v-if="customerSummary.mobilephone != ''" cols="6">
									{{customerSummary.mobilephone}}
								</b-col>
								<b-col v-else cols="6" class="not-specified">
									Not Specified
								</b-col>
							</b-row>
						</b-card-body>
					</b-card>
				</b-col>
				<b-col :lg="invoices.length > 0 ? 5 : 7" xs="12" class="p-0">
					<b-card no-body class="mh-card">
						<b-card-header>
							<h3 class="card-title">Plan Management Funding</h3>
						</b-card-header>
						<b-card-body class="budgets">
							<b-row class="mb-4">
								<b-col class="text-center pl-2 pr-2">
									<span class="amount">{{pmFundingTotal | currency}}</span>
									<br />
									<span class="label">Total Budget</span>
								</b-col>
								<b-col class="available text-center pl-2 pr-2">
									<span class="amount">{{pmFundingAvailable | currency}}</span>
									<br />
									<span class="label">Available Budget</span>
								</b-col>
								<b-col class="text-center pl-2 pr-2">
									<span class="amount">{{pmFundingUsed | currency}}</span>
									<br />
									<span class="label">Used Budget</span>
								</b-col>
							</b-row>
							<div class="mh-shift-list">
								<b-nav vertical>
									<b-nav-item v-for="(pmFundingBalance, index) in pmFundingBalances" :key="index">
										<label class="mh-list-label">{{pmFundingBalance.servicetype}}</label>
										<div class="mh-list-content">
											<div v-if="pmFundingBalance.provider.length > 0" class="text-secondary mb-2">
												<small>{{pmFundingBalance.provider}}</small>
											</div>
											<a href="#" class="mh-list-title">{{pmFundingBalance.balance | currency}} <small>available of</small> {{pmFundingBalance.total | currency}}</a>
											<div class="d-flex">
												<div class="mh-formTo-time">{{pmFundingBalance.dates}}</div>
												<div class="mh-list-time ml-auto">
													<svg width="80px" height="80%" viewBox="0 0 42 42" class="donut">
														<circle class="donut-ring" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#d2d3d4" stroke-width="5"></circle>
														<circle class="donut-segment" cx="21" cy="21" r="15.91549430918954" fill="transparent" :stroke="(pmFundingBalance.percent * 100) < 80 ? '#5aba47' : '#e94a79'" stroke-width="5" :stroke-dasharray="`${pmFundingBalance.percent * 100} ${100 - (pmFundingBalance.percent * 100)}`" stroke-dashoffset="25"></circle>
														<g class="info">
															<text class="percent" x="50%" y="50%" alignment-baseline="central" text-anchor="middle" font-size="8">{{pmFundingBalance.percent | percent}}</text>
														</g>
													</svg>
													<br />
													<a @click="$store.dispatch('Content/show', 'InvoicesClientContent')"><small>View Invoices</small></a>
												</div>
											</div>
										</div>
									</b-nav-item>
								</b-nav>
							</div>
						</b-card-body>
					</b-card>
				</b-col>
				<b-col v-if="invoices.length > 0" lg="3" xs="12" class="pr-0">
					<b-card no-body class="mh-card">
						<b-card-header>
							<h3 class="card-title">Invoice Approval</h3>
						</b-card-header>
						<b-card-body class="invoices">
							<div class="mh-shift-list">
								<b-nav vertical>
									<b-nav-item v-for="(invoice, index) in invoices" :key="index">
										<label class="mh-list-label">{{invoice.supplier}}</label>
										<div class="mh-list-content">
											<b-row class="text-secondary mb-2" no-gutters>
												<b-col>
													<small># {{invoice.invoicenumber}}</small>
												</b-col>
												<b-col class="pr-0 pl-0">
													<div>
														<small>{{moment(invoice.date, "D/MM/YYYY hh:mm:ss A").format("DD MMM YYYY")}}</small>
													</div>
												</b-col>
											</b-row>
											<b-row no-gutters>
												<b-col>
													<a href="#" class="mh-list-title">{{invoice.totalamount | currency}}</a>
												</b-col>
											</b-row>
											<b-row no-gutters>
												<b-col>
													<b-button @click="showApproveInvoiceForm(invoice)" class="btn-default btn-green scaled70 mr-2 mb-0">Approve</b-button>
												</b-col>
												<b-col>
													<b-button @click="showRejectInvoiceForm(invoice)" class="btn-default scaled70">Reject</b-button>
												</b-col>
											</b-row>
										</div>
									</b-nav-item>
								</b-nav>
							</div>
						</b-card-body>
					</b-card>
				</b-col>
			</b-row>
		</div>

		<b-modal :visible="isViewingSetInvoiceStatusForm" @hide="hideSetInvoiceStatusForm" modal-class="shift-summary" body-class="mh-off-middle" size="md" hide-footer>
			<template slot="modal-title">
				<h5 class="modal-title">{{approving ? "Approve" : "Reject"}} Invoice</h5>
			</template>
			<template slot="default">
				<SetInvoiceStatusForm :data="selectedInvoice"
									  :approving="approving"
									  :rejecting="rejecting"
									  @close-form="hideSetInvoiceStatusForm"
									  @save-form="saveSetInvoiceStatusForm" />
			</template>
		</b-modal>
	</div>
</template>

<script>
	import ContentTitle from "./partials/ContentTitle"
	import ProfileImage from "./partials/ProfileImage"
	import SetInvoiceStatusForm from "./partials/SetInvoiceStatusForm"

	export default {
		name: 'DashboardClientContent',
		components: {
			ContentTitle,
			ProfileImage,
			SetInvoiceStatusForm
		},
		data: function () {
			return {
				selectedInvoice: null,
				approving: false,
				rejecting: false
			}
		},
		mounted: function () {
			this.$store.dispatch("Customers/getCustomerSummary", this.profile.userid)
			this.$store.dispatch("Funding/getPmFundingBalances")
		},
		watch: {
			invoiceStatuses: {
				immediate: true,
				handler(newValue, oldValue) {
					if (newValue.length > 0) {
						this.$store.dispatch("Invoices/getInvoices", 3)
					}
				}
			}
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			alerts: function () {
				return this.$store.state.Alerts.alerts.map(x => x.alert)
			},
			customerSummary: function () {
				return this.$store.state.Customers.customerSummary
			},
			pmFundingBalances: function () {
				return this.$store.state.Funding.pmFundingBalances
					.slice()
					.sort(this.$store.getters["Helper/compareValues"]("fromdate", "asc"))
			},
			invoices: function () {
				return this.$store.state.Invoices.invoices
			},
			invoiceStatuses: function () {
				return this.$store.state.Invoices.invoiceStatuses.slice().filter(x => parseInt(x.value) > 2)
			},
			profilePicture: function () {
				return this.profile.profilepic
			},
			pmFundingTotal: function () {
				return this.$store.state.Funding.pmFundingBalances
					.map(x => parseFloat(x.total))
					.reduce(function (a, b) {
						return a + b
					}, 0)
			},
			pmFundingAvailable: function () {
				return this.$store.state.Funding.pmFundingBalances
					.map(x => parseFloat(x.balance))
					.reduce(function (a, b) {
						return a + b
					}, 0)
			},
			pmFundingUsed: function () {
				return this.$store.state.Funding.pmFundingBalances
					.map(x => parseFloat(x.used))
					.reduce(function (a, b) {
						return a + b
					}, 0)
			},
			isViewingSetInvoiceStatusForm: function () {
				return this.approving || this.rejecting
			},
		},
		methods: {
			showApproveInvoiceForm: function (invoice) {
				this.selectedInvoice = invoice

				this.approving = true
			},
			showRejectInvoiceForm: function (invoice) {
				this.selectedInvoice = invoice

				this.rejecting = true
			},
			hideSetInvoiceStatusForm: function () {
				this.selectedInvoice = null

				this.approving = false
				this.rejecting = false
			},
			saveSetInvoiceStatusForm: function () {
				var $this = this

				this.$store.dispatch("Invoices/getInvoices", 3).then(function () {
					$this.hideSetInvoiceStatusForm()
				})
			}
		}
	}
</script>

<style scoped>
	.card.mh-card .card-body.profile {
		padding: 20px 0 !important;
	}

		.profile .profile-picture {
			width: 150px;
			height: 150px;
			padding: 5px;
			background-color: #ffffff;
			border-radius: 50%;
			box-shadow: 0 0 29px 0px #0000003d;
			z-index: 9;
			object-fit: cover;
			object-position: center center;
		}

		.profile .name {
			font-size: 25px;
			font-weight: bold;
		}

		.profile .number {
			font-size: 12px;
			color: #a5a5a5;
		}

		.profile .label {
			text-align: right;
			font-weight: bold;
		}

		.profile .not-specified {
			color: #dcdcdc;
		}

	.card.mh-card .card-body.budgets {
		padding: 20px 15px !important;
	}

		.budgets .available {
			border-left: 1px solid #b9b9b9;
			border-right: 1px solid #b9b9b9;
		}

		.budgets .amount {
			font-size: 19px;
			font-weight: bold;
			color: #000000;
		}

		.budgets .label {
			font-size: 13px;
		}

		.budgets .mh-shift-list .circle-chart .circle {
			animation: circle-chart-fill 2s reverse;
			transform: rotate(270deg);
			transform-origin: center;
		}

	.card.mh-card .card-body.invoices {
		padding: 5px 15px !important;
	}

		.card.mh-card .card-body.invoices .approve,
		.card.mh-card .card-body.invoices .reject {
			cursor: pointer;
		}

		.card.mh-card .card-body.invoices .nav-item .nav-link{
			padding: 0;
		}
</style>